/* unplugin-vue-components disabled */import script from "./prize.vue?vue&type=script&setup=true&lang=js"
export * from "./prize.vue?vue&type=script&setup=true&lang=js"

import "./prize.vue?vue&type=style&index=0&id=9995ed6c&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9995ed6c"]])

export default __exports__